import { Flex, Form } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { CONTRACT_ADDRESS_TYPE, CreateContractRequest, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";

import { editContract } from "services";
import { useStores } from "stores";
import { CustomButton, DefaultInput, NumberInput } from "ui";
import { requestWithNotify } from "utils";
import { _greaterOrEqual, _isNumericWithPrecision, _isRequired, _lessOrEqual } from "utils/form/simple-validation";

export const ContractEditAddressModal = observer(({ type }: { type: CONTRACT_ADDRESS_TYPE }) => {
  const { actionModals, contractCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();
  const value = Form.useWatch(type, form);

  const saveContract = async () => {
    setLoading(true);
    const values: CreateContractRequest = form.getFieldsValue();
    const formData = {
      ...values,
    };

    try {
      const res = await requestWithNotify({
        fetchFn: () => editContract({ id: contractCard.card.id }, formData),
        openNotification,
        successMsg: "Адрес успешно отредактирован",
        errorMsg: "Не удалось отредактировать адрес",
      });

      if (res.result) {
        await requestWithNotify({
          fetchFn: () => contractCard.fetchCardById(contractCard.card.id),
          openNotification,
          showErrorNotification: false,
          delay: 1000,
        });
      }
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  const closeModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical gap="large">
      <Form
        form={form}
        name="editFee"
        initialValues={{
          [type]: contractCard.card[type],
        }}
        onFinish={() => saveContract()}
      >
        <Flex vertical>
          <Form.Item
            name={type}
            rules={[_isRequired("Поле обязательно для ввода")]}
            validateDebounce={FORM_VALIDATION_DEBOUNCE}
          >
            <DefaultInput placeholder="Введите адрес" maxLength={255} />
          </Form.Item>
        </Flex>
        <Form.Item>
          <Flex gap="large">
            <CustomButton htmlType="submit" disabled={loading || !value} loading={loading} className="full-width">
              Сохранить изменения
            </CustomButton>
            <CustomButton
              htmlType="button"
              disabled={loading}
              loading={loading}
              type="default"
              onClick={closeModal}
              className="full-width"
            >
              Отменить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
